import Cookies from 'js-cookie';
import globalConf from '@/config/globalConf';

const { tokenName, xsrfCookieName } = globalConf;

export const getToken = () => Cookies.get(tokenName);

export const setToken = token => Cookies.set(tokenName, token);

export const removeToken = () => Cookies.remove(tokenName);

export const getXsrfCookieToken = () => Cookies.get(xsrfCookieName);

export const setXsrfCookieToken = token => Cookies.set(xsrfCookieName, token);

export const removeXsrfCookieToken = () => Cookies.remove(xsrfCookieName);
